import { apiRequest, apiRequestPaginated } from './client';
import type { Review } from '../types';

type ApiReview = {
  _id: string;
  rating?: number;
  review?: string | null;
  createdAt?: string;
  user?: { _id?: string; name?: string | null } | null;
  provider?: { _id?: string; name?: string | null } | null;
  job?: { _id?: string; title?: string } | null;
};

export type ReviewCounts = {
  reviewCounts: Record<string, number>;
  totalCount: number;
};

export const mapApiReview = (review: ApiReview): Review => ({
  id: review._id,
  jobId: review.job?._id || '',
  reviewer: review.user?.name?.trim() || '—',
  reviewerType: 'Customer',
  reviewedParty: review.provider?.name?.trim() || '—',
  reviewedPartyType: 'Provider',
  rating: review.rating || 0,
  text: review.review || '',
  date: review.createdAt || '',
  status: 'Active',
});

export const reviewsApi = {
  getReviewCounts: async (): Promise<ReviewCounts> => {
    return apiRequest<ReviewCounts>('/admin/review/get-review-counts', {
      method: 'GET',
      auth: true,
    });
  },

  getReviews: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<{ reviews: Review[]; total: number }> => {
    const query = new URLSearchParams({
      page: String(params?.page || 1),
      limit: String(params?.limit || 1000),
    });

    const { data, pagination } = await apiRequestPaginated<{ reviews: ApiReview[] }>(
      `/admin/review/get-reviews?${query.toString()}`,
      { method: 'GET', auth: true }
    );

    return {
      reviews: (data.reviews || []).map(mapApiReview),
      total: pagination.totalItems || 0,
    };
  },
};
